import React from 'react'
import { Outlet } from 'react-router-dom'
import { useResizeDetector } from 'react-resize-detector'

import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import HeartbeatLoader from '@/components/ui/loaders/HeartbeatLoader'

import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import OfflineHeader from './header/OfflineHeader'
import OfflineSidebar from './OfflineSidebar'
import OfflineFooter from './OfflineFooter'

export type OfflineLayoutProps = {}

export default function OfflineLayout(props: OfflineLayoutProps) {
    const { width: pageContainerWidth, ref: pageContainerRef } = useResizeDetector()
    const theme = useTheme()
    const authUser = useAppSelector(selectAuthUser)
    const { isOfflineDatabaseReady } = useOfflineMode()

    return (
        <Box ref={pageContainerRef} sx={{ height: '100%', backgroundColor: theme.palette.background.default }}>
            <Stack direction={{ xs: 'column', md: 'row' }}>
                {(pageContainerWidth || 0) >= theme.breakpoints.values.md && <OfflineSidebar />}
                <Stack
                    minHeight="100vh"
                    sx={{
                        flex: 1,
                        position: 'relative',
                        minWidth: { xs: '100%', md: 'unset' },
                        overflow: 'auto'
                    }}
                >
                    <OfflineHeader />
                    {!isOfflineDatabaseReady ? (
                        <Stack flex={1} alignItems="center" justifyContent="center">
                            <HeartbeatLoader sx={{ transform: 'scale(4)' }} />
                        </Stack>
                    ) : (
                        <Outlet />
                    )}
                    <OfflineFooter />
                </Stack>
            </Stack>
        </Box>
    )
} 